const Login = () => import(/* webpackChunkName: "login" */ './Login.vue')
const Company = () => import(/* webpackChunkName: "setcompany" */ './Company.vue')
const Captation = () => import(/* webpackChunkName: "captation" */ './Captation.vue')

const route = {
  path: 'login',
  name: 'Login',
  component: Login,
  meta: {
    requiresLogin: false,
    requiresCompany: false,
    permissions: []
  }
}

const company = {
  path: 'setcompany',
  name: 'Seleção',
  component: Company,
  meta: {
    requiresLogin: true,
    requiresCompany: false,
    permissions: []
  }
}

const captation = {
  path: 'captation',
  name: 'Orçamento',
  component: Captation,
  meta: {
    requiresLogin: false,
    requiresCompany: false,
    permissions: []
  }
}

export default {
  route,
  company,
  captation
}



// WEBPACK FOOTER //
// ./src/views/login/index.js